export default {
  GET_ALL_USERS_BEGIN: "GET_ALL_USERS_BEGIN",
  GET_ALL_USERS_SUCCESS: "GET_ALL_USERS_SUCCESS",
  GET_ALL_USERS_FAILURE: "GET_ALL_USERS_FAILURE",

  SET_MANAGER_STATUS_BEGIN: "SET_MANAGER_STATUS_BEGIN",
  SET_MANAGER_STATUS_SUCCESS: "SET_MANAGER_STATUS_SUCCESS",
  SET_MANAGER_STATUS_FAILURE: "SET_MANAGER_STATUS_FAILURE",
};



// WEBPACK FOOTER //
// ./src/modules/manager/constants.js